<template>
  <!-- :class="{ 'items-center': !supportWxAuth && pageStatus == 1 }" -->
  <div class="h-[100vh] relative min-h-[750] justify-center flex w-[100%]">
    <dg-head class="absolute top-[0] w-[100%] left-[0]">
      <div class="flex items-center">
        <p class="cursor-pointer pr-[40]" @click="changePageStatus"><i class="icon">&#xe677;</i> {{ pageStatus == 1 ?
          "注册" : "登录" }}</p>
        <a :href="ENV.official" target="_blank"> <el-button size="mini" type="primary">返回首页</el-button></a>
      </div>
    </dg-head>

    <!-- sm:mt-[6vh] sm:transform-[scale(0.8)] smm:mt-[6vh] smm:transform-[scale(0.8)] sml:mt-[8vh] sml:transform-[scale(0.8)] mdl:transform-[scale(0.85)] md:mt-[14vh] lg:mt-[14vh] lg:transform-[scale(1)] sxl:mt-[7vh] sxl:transform-[scale(0.85)] -->
    <!-- media:login_box mt-[6vw] xl:transform-[scale(0.9)] sxl:transform-[scale(0.85)] lg:mt-[3vw] lg:transform-[scale(0.8)] -->
    <div class="login_wrapper">
      <div class="w-[1200] mx-[auto] rounded-[4] bg-[#fff] flex shadow relative">
        <div v-if="showScanCode" class="absolute right-[0] top-[0] z-[999]" @click="isWxScan = true">
          <img class="w-[50] h-[50] cursor-pointer" src="@/assets/img/public/scan_wx.png" alt="" />
        </div>
        <div class="w-[740]">
          <img v-if="getCityAssetsFile('login-img.jpg')" :src="getCityAssetsFile('login-img.jpg')"
            class="w-[100%] h-[612]" alt="" />
        </div>
        <div class="flex-1 self-start">
          <template v-if="pageStatus == 1">
            <loginByWxScan v-if="isWxScan" @handleLogint="changeLoginType"></loginByWxScan>
            <loginByOthers :supportWxAuth="supportWxAuth" :loginBy="loginType" @loginByWxScan="isWxScan = true"
              @goToRegister="pageStatus = 2" v-else> </loginByOthers>
          </template>
          <template v-if="pageStatus == 2">
            <quickRegister @changeToLogin="pageStatus = 1"></quickRegister>
          </template>
        </div>
      </div>
    </div>
    <!-- <div class="w-[100] h-[100] bg-[#333] transform-[scale(0.8)]"></div> -->
    <div class="absolute bottom-[0] w-[100%] pb-[32] left-[0]">
      <dg-copyright></dg-copyright>
    </div>
    <dg-contactus v-if="['ji-nan'].includes(conf.city)"></dg-contactus>
  </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import loginByOthers from "./loginByOthers.vue";
import loginByWxScan from "./loginByWxScan.vue";
import quickRegister from "./quickRegister.vue";
export default {
  mixins: [mixin],
  data() {
    return {
      isLogin: true,
      isWxScan: false,

      loginType: 0,
      pageStatus: 1, // 1是登录 2是注册
      supportWxAuth: false,
    };
  },
  components: {
    loginByOthers,
    loginByWxScan,
    quickRegister,
  },
  watch: {},
  computed: {
    showScanCode() {
      return this.supportWxAuth && this.pageStatus == 1 && !this.isWxScan;
    },
  },
  methods: {

    changeLoginType(t) {
      this.isWxScan = false;
      this.loginType = t;
    },
    changePageStatus() {
      this.pageStatus = this.pageStatus == 2 ? 1 : 2;
      this.isWxScan = false;
    },
    // 获取是否支持微信小程序授权验证手机号
    getIsSupportWxAuth() {
      ajax.post({
        url: "/customer/common/supportWxappletMobileAuthQrcode",
        data: {},
        self: this,
        success: (res) => {
          if (res) {
            this.supportWxAuth = res.support;
          }
        },
      });
    },
  },
  mounted() { },
  created() {

    this.getIsSupportWxAuth();

  },
};
</script>
<style scoped lang="less">
// @import "~@/assets/css/var.less";

.shadow {
  box-shadow: 0 2px 10px 0 rgba(45, 72, 97, 0.1);
}



.transform {
  transform: translate(-50%, -50%);
}

@media screen and (min-width: 1400px) {
  .login_wrapper {
    margin-top: 6vh;
    transform: scale(0.8);
  }
}

@media screen and (min-width: 1440px) {
  .login_wrapper {
    margin-top: 6vh;
    transform: scale(0.8);
  }
}

@media screen and (min-width: 1450px) {
  .login_wrapper {
    margin-top: 8vh;
    transform: scale(0.8);
  }
}

@media screen and (min-width: 1500px) {
  .login_wrapper {
    transform: scale(0.85);
  }
}

@media screen and (min-width: 1550px) {
  .login_wrapper {
    margin-top: 14vh;
    transform: scale(1);
  }
}

@media screen and (min-width: 1700px) {
  .login_wrapper {
    margin-top: 7vh;
    transform: scale(0.85);
  }
}
</style>
